var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9722 7.16672C30.6389 9.50005 30.6389 14.5001 30.6389 14.5001C30.6389 14.5001 30.6389 19.4445 29.9722 21.8334C29.6389 23.1667 28.5833 24.1667 27.3056 24.5001C24.9167 25.1112 15.4722 25.1112 15.4722 25.1112C15.4722 25.1112 5.97222 25.1112 3.58333 24.5001C2.30556 24.1667 1.25 23.1667 0.916667 21.8334C0.25 19.4445 0.25 14.5001 0.25 14.5001C0.25 14.5001 0.25 9.50005 0.916667 7.16672C1.25 5.83339 2.30556 4.77783 3.58333 4.4445C5.97222 3.77783 15.4722 3.77783 15.4722 3.77783C15.4722 3.77783 24.9167 3.77783 27.3056 4.4445C28.5833 4.77783 29.6389 5.83339 29.9722 7.16672ZM12.3611 19.0001L20.25 14.5001L12.3611 10.0001V19.0001Z",
    fill: "#B43A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.89ff54898803b7d25e579bb08d060e12.svg";
export { ForwardRef as ReactComponent };